// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".appointment-dropdown-description[data-v-96caeb88]{font-weight:100;padding-left:1.6em}.bold-text[data-v-96caeb88]{font-weight:bolder;cursor:pointer;color:#7a0000;text-decoration:none;background-color:rgba(0,0,0,0)}.bold-text[data-v-96caeb88]:hover{color:inherit}", ""]);
// Exports
module.exports = exports;
